import { gql } from '@apollo/client'

export const UPDATE_CAMPAIGN_VAST_REQUEST_MULTIPLIER = gql`
  mutation updateVastRequestMultipliers($campaignId: ID!, $multiplier: Float!) {
    updateVastRequestMultipliers(input: { campaignId: $campaignId, multiplier: $multiplier }) {
      success
      errors
    }
  }
`
